import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { WorkspaceApp } from '@2a-stack/ui';
import { masterWorkspace } from './workspace';
import '@2a-stack/ui/styles.css';

createRoot(document.getElementById('root')!).render(
    <StrictMode><WorkspaceApp config={masterWorkspace} /></StrictMode>
);
